/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'check-in-circle': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<g data-name="Layer 2"><g data-name="Layer 1" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><path pid="0" d="M4.7 8.7L6.5 11 11 5.5"/><circle pid="1" cx="8" cy="8" r="7.5"/></g></g>',
    lastMod: '1793616840798.3528'
  }
})
